import React, { useEffect, useState } from "react";

// chakra imports
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  useDisclosure,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import Content from "components/sidebar/components/Content";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import PropTypes from "prop-types";

// Assets
import { IoMenuOutline } from "react-icons/io5";
import { useScrollSpy } from "hooks/useScrollSpy";

// const useScrollSpy = (routes) => {
//   const [activeId, setActiveId] = useState("");

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         // Cari entry yang paling visible
//         let maxVisibility = 0;
//         let mostVisibleId = "";

//         entries.forEach((entry) => {
//           if (entry.isIntersecting && entry.intersectionRatio > maxVisibility) {
//             maxVisibility = entry.intersectionRatio;
//             mostVisibleId = entry.target.id;
//           }
//         });

//         if (mostVisibleId) {
//           setActiveId(mostVisibleId);
//         }
//       },
//       {
//         rootMargin: "-10% 0px -50% 0px", // Adjust sesuai kebutuhan
//         threshold: [0, 0.25, 0.5, 0.75, 1], // Multiple thresholds untuk akurasi lebih baik
//       }
//     );

//     // Collect all route IDs that need to be observed
//     const routeIds = [];

//     const extractIds = (routes) => {
//       routes.forEach((route) => {
//         if (route.category) {
//           extractIds(route.items);
//         } else if (route.path && route.path.startsWith("#")) {
//           const id = route.path.replace("#", "");
//           routeIds.push(id);
//         }
//       });
//     };

//     extractIds(routes);

//     // Observe semua elemen
//     routeIds.forEach((id) => {
//       const element = document.getElementById(id);
//       if (element) {
//         observer.observe(element);
//       }
//     });

//     return () => observer.disconnect();
//   }, [routes]);

//   return activeId;
// };

function Sidebar(props) {
  const { routes, hideContent = false } = props;
  const activeId = useScrollSpy(routes);

  let variantChange = "0.2s linear";
  let shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  // Chakra Color Mode
  let sidebarBg = useColorModeValue("white", "navy.800");
  let sidebarMargins = "0px";

  // SIDEBAR
  return (
    <Box
      display={{ sm: "none", xl: "block" }}
      w="100%"
      position="fixed"
      minH="100%"
    >
      <Flex justifyContent="space-between">
        <Box
          bg={sidebarBg}
          transition={variantChange}
          w="250px"
          h="100vh"
          m={sidebarMargins}
          minH="100%"
          overflowX="hidden"
          boxShadow={shadow}
        >
          <Scrollbars
            autoHide
            renderTrackVertical={renderTrack}
            renderThumbVertical={renderThumb}
            renderView={renderView}
          >
            <Content routes={routes} activeId={activeId} />
          </Scrollbars>
        </Box>
        <Box
          bg={sidebarBg}
          transition={variantChange}
          w="250px"
          h="100vh"
          m={sidebarMargins}
          minH="100%"
          overflowX="hidden"
          boxShadow={shadow}
        ></Box>
      </Flex>
    </Box>
  );
}

// FUNCTIONS
export function SidebarResponsive(props) {
  let sidebarBackgroundColor = useColorModeValue("white", "navy.800");
  let menuColor = useColorModeValue("black", "white");
  const { routes } = props;
  const activeId = useScrollSpy(routes);

  // // SIDEBAR
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  // let isWindows = navigator.platform.startsWith("Win");
  //  BRAND

  return (
    <Flex display={{ sm: "flex", xl: "none" }} alignItems="center">
      <Flex ref={btnRef} w="max-content" h="max-content" onClick={onOpen}>
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my="auto"
          w="20px"
          h="20px"
          me="10px"
          _hover={{ cursor: "pointer" }}
        />
      </Flex>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent
          w="285px"
          maxW="285px"
          pt={70}
          bg={sidebarBackgroundColor}
        >
          <DrawerCloseButton
            zIndex="3"
            alignSelf="end"
            pr={10}
            pt={5}
            onClose={onClose}
            _focus={{ boxShadow: "none" }}
            _hover={{ boxShadow: "none" }}
          />
          <DrawerBody maxW="285px" px="0rem" pb="0" height="100vh">
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <Content routes={routes} activeId={activeId} />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
  hideContent: PropTypes.bool,
};

export default Sidebar;
